import React from 'react';
import styles from './VotingPageLayout.module.scss';
import { OrganizationAvatar } from '@Components/OrganizationAvatar/OrganizationAvatar';

export interface VotingPageLayoutProps {
  children: React.ReactNode;
  // The avatar can be undefined while data is loading.
  avatar?: string;
}

export const VotingPageLayout = ({ children, avatar }: VotingPageLayoutProps) => {
  return (
    <>
      <div className={styles.headerWithImage}>
        {avatar && <OrganizationAvatar className={styles.avatarWrapper} avatarImage={avatar} />}
      </div>
      <div className={styles.body}>{children}</div>
    </>
  );
};
